export default "__VITE_ASSET__htlIZBKy__"